'use client';

import { StaticImageBlock } from '@/components/content-blocks/static-image-block';

import Providers from './providers';
import { useLogger } from './providers/logger';

import type { Environment } from './types';

const image = {
  url: '/error-page-image.png',
  width: 1000,
  height: 1000,
  description: 'Error page 500',
};
const heading = "Something's not right...";
const body =
  "It's not you, it's us. Please check this page again later to try again. In the meantime you can try one of these links below.";
const quickLinks = {
  header: 'Quick Links',
  links: [
    { href: '/', label: 'Home' },
    {
      href: '/compare-energy-plans',
      label: 'See energy plans',
    },
    { href: '/contact-us', label: 'Contact us' },
  ],
};
const alertMessage = 'Error 500:';

export default function Custom500ErrorPage({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const logger = useLogger();

  logger.error(error);

  return (
    <Providers env={process.env.ENV! as Environment}>
      <div className="min-h-lvh bg-gray-50 py-40">
        <StaticImageBlock
          heading={heading}
          body={body}
          image={image}
          linksBlock={quickLinks}
          alertMessage={alertMessage}
        />
      </div>
    </Providers>
  );
}
